import { usePageTitle } from '@calendly/hooks'
import { TitleText } from '@calendly/ui/components/typography'

import { useI18n } from 'locales'

const FormTitle = ({ isPoll }) => {
  const { i18n } = useI18n()
  const titleText = isPoll ? i18n.t('booking.templates.poll.share_times') : i18n.t('booking.templates.enter_details')

  const windowTitle = isPoll ? i18n.t('booking.templates.poll.share_times') : i18n.t('booking.templates.enter_booking_details')

  usePageTitle(`${windowTitle} - Calendly`)

  return <TitleText level={2} size="large">{titleText}</TitleText>
}

export default FormTitle
